import React, { Component } from 'react'
import styled from 'styled-components'
import { Button, Colors } from 'advenio-components'

const CardsLogo = {
  MAST: '/assets/mastercard.svg',
  AMEX: '/assets/Amex.svg',
  VISA: '/assets/Visa.svg',
  visa: '/assets/Visa.svg',
  'american express': '/assets/Amex.svg',
  mastercard: '/assets/mastercard.svg',
}
const AuthButtonsContainer = styled.div`
  margin: 8px 16px;
  display: flex;
`
const Separator = styled.div`
  height: 12px;
  border: 1px solid gray;
  width: 0px;
  margin: 2px 4px;
`
const AuthButtons = styled.a`
  color: ${Colors.blue500};
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  &:hover{
    text-decoration: underline;
  }
`

const Digits = styled.div`
  margin: 0px 8px 0 16px;
`

const Date = styled.div`
  margin: 0px 8px;
`

const CardContainer = styled.div`
  background: ${Colors.gray200};
  border: 1px solid #cecece;
  border-radius: 4px;
  padding: 8px 0 8px 0;
  margin: 8px 16px 8px 16px;
  -webkit-transition: height 1s; /* For Safari 3.1 to 6.0 */
  transition: height 1s;
`
const CardHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  @media (max-width:767px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const CardLogo = styled.img`
  margin:0 8px 0 8px;
  height: 35px;
  border-radius: 4px;
`
const CardInfoHeader = styled.div`
  font-size: 12px;
  color:#4A4A4A;
  opacity: .7;
  font-weight: bold;
  flex: 1;
  display: flex;
`

const CardActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

const CardActive = styled.div`
  display: ${props => props.active ? 'block' : 'none'};
  width:40px;
  height: 20px;
  background: #328EE1;
  color:white;
  font-size: 10px;
  text-transform: capitalize;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
`
const ArrowIcon = styled.div`
  width: 8px;
  height: 8px;
  transform: ${props => props.open ? 'rotate(0deg)' : 'rotate(-90deg);'};
  border-bottom-left-radius: 2px;
  border-top-left-radius: 2px;
  border-bottom-right-radius: 2px;
  -webkit-transition: transform 350ms; /* For Safari 3.1 to 6.0 */
  transition: transform 350ms;
  display: flex;
  justify-content: center;
  align-items: center;
`
const ArrowIconContainer = styled.div`
  width: auto;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 8px;
`
const CardInfo = styled.div`
  height: ${props => props.open ? 'auto' : 0};
  overflow: ${props => props.open ? 'auto' : 'hidden'};
  visibility: ${props => props.open ? 'visible' : 'hidden'};
  opacity: ${props => props.open ? 1 : 0};
  -webkit-transition: visibility 500ms, opacity 500ms;/* For Safari 3.1 to 6.0 */
  transition: visibility 500ms, opacity 500ms;
  margin: ${props => props.open ? '8px' : 0};;
  @media (max-width:767px) {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
  }
`
const NewButton = styled(Button)`
  color:#4A4A4A;
  padding: 0 4px 0 4px;
  margin-right: 2px;
  margin-left: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  span {
    font-size: 12px;
    margin-left: 0;
    margin-right: 4px;
  }
  svg{
    width: 16px;
    height: 16px;
  }
`
const Icon = styled.img`
  width: 15px;
  margin: 4px;
`

const InfoRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 8px;
`

const InfoLabel = styled.span`
  font-size: 12px;
  text-align: right;
  color: #4A4A4A;
  opacity: .7;
`

const InfoData = styled.span`
  font-size: 12px;
  text-align: left;
  color: #4A4A4A;
  margin-left: 8px;
`
class CreditCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      openModal: false,
    }
  }

  componentDidMount = () => {
    const { openedByDefault, card } = this.props
    if (card.is_default) {
      this.setState({ open: true })
    }
    if (openedByDefault) {
      this.setState({ open: openedByDefault })
    }
  }
  componentWillReceiveProps = ({ openedByDefault }) => {
    this.setState({ open: openedByDefault })
  }

  openCard = () => {
    this.setState({ open: !this.state.open })
  }

  editCard = () => {
    const { onEditCard, card, parent } = this.props
    onEditCard(card, parent)
  }

  renderInactiveActions = () => {
    const { card, onUnauth, onActivate } = this.props
    if (card.is_default) {
      return null
    }
    return (
      (<AuthButtonsContainer>
        <AuthButtons onClick={() => { onActivate(card.id, false) }}>
          Usar por Default
        </AuthButtons>
        <Separator />
        <AuthButtons onClick={() => { onUnauth(card.id, false) }}>
          Desautorizar
        </AuthButtons>
      </AuthButtonsContainer>)
    )
  }

  render() {
    const { card, parent, auth, onAuth, onUnauth, onDelete } = this.props
    return (
      <CardContainer open={this.state.open}>
        <CardHeader>
          <ArrowIconContainer onClick={this.openCard}>
            <ArrowIcon open={this.state.open}>
              <img src="/assets/blue_arrow.svg" />
            </ArrowIcon>
            <CardLogo src={CardsLogo[card.card_brand]} />
            <CardInfoHeader>
              <Digits>****{card.last_four}</Digits>
              {card.exp_year && card.exp_month &&
              <Date>{card.exp_month}/{card.exp_year}</Date>
              }
              {card.is_default && <CardActive active>
                Default
              </CardActive>}
            </CardInfoHeader>
          </ArrowIconContainer>
          <CardActions>
            {auth ? this.renderInactiveActions() :
              (<AuthButtonsContainer>
                <AuthButtons onClick={() => { onAuth(card.id, true) }} >
                  Autorizar
                </AuthButtons>
                <Separator />
                <AuthButtons onClick={() => { onDelete(card.id, true) }}>
                  Eliminar
                </AuthButtons>
              </AuthButtonsContainer>)}
          </CardActions>
        </CardHeader>
        <CardInfo open={this.state.open}>
          {/* <InfoRow>
            <InfoLabel>Nombre del Tarjetahabiente:</InfoLabel>
            <InfoData>{`${parent.name} ${parent.lastName} ${parent.secondLastName}`}</InfoData>
          </InfoRow> */}
          <InfoRow>
            <InfoLabel>Número de Tarjeta:</InfoLabel>
            <InfoData>****{card.last_four}</InfoData>
          </InfoRow>
          <InfoRow>
            {card.exp_year && card.exp_month &&
              <div>
                <InfoLabel>Fecha de Expiracion:</InfoLabel>
                <InfoData>{card.exp_month}/{card.exp_year}</InfoData>
              </div>
            }
          </InfoRow>
          <InfoRow>
            <InfoLabel>Tipo de tarjeta:</InfoLabel>
            <InfoData>{card.card_brand}</InfoData>
          </InfoRow>
        </CardInfo>
      </CardContainer>
    )
  }
}

export default CreditCard



// WEBPACK FOOTER //
// ./src/Components/CreditCard.jsx